<template>
  <div>
    <v-select
      :items="items"
      :disabled="isDisabled"
      v-model="selectedStatusId"
      label="Status"
      item-text="name"
      item-value="id"
      @change="onChange($event)"
      :outlined="outlined"
    ></v-select>
  </div>
</template>

<script>
import { SERVICE_STATUSES_LIST } from "../../../constants/graphql";
export default {
  name: "ServiceStatusListSelect",
  props: {
    outlined: {
      type: Boolean,
      default: () => false,
    },
    serviceStatusId: {
      type: String,
      default: () => "U2VydmljZVN0YXR1cy0x",
    },
    isDisabled: {
      type: Boolean,
      default: () => true,
    },
    serviceStatusName: {
      type: String,
      default: () => "",
    },
    value: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      items: [{ name: "Quotation", id: "1" }],
      selectedStatusId:
        this.value != ""
          ? this.value
          : this.serviceStatusId
          ? this.serviceStatusId
          : "U2VydmljZVN0YXR1cy0x",
      serviceStatuses: {},
    };
  },
  methods: {
    onChange(e) {
      if (typeof e == "string") {
        var selectedItem = this.items.find((item) => item.id == e);
        this.$emit("onSelect", selectedItem);
        this.$emit("input", selectedItem.id);
      }
    },
  },
  watch: {
    serviceStatusId: function (val) {
      this.selectedStatusId = val;
    },
    value(newVal) {
      this.statusId = newVal;
    },
  },
  apollo: {
    serviceStatuses: {
      query: SERVICE_STATUSES_LIST,
      result({ data }) {
        this.items = data.serviceStatuses.edges.map((node) => ({
          ...node.node,
        }));
      },
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/gt/shared/ServiceStatusListSelect.vue